module.exports = "<div class=\"container mt-5 pt-5\" [innerHtml]=\"myTemplate\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/landing/info/eula/eula.component.html
// module id = ./src/app/landing/info/eula/eula.component.html
// module chunks = main